module.exports = __webpack_public_path__ + "static/media/history4.6108614b.jpg";